import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/alerta';

const alertsEndpoint = {
    findAlerts: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        // let endpoint = `${context}/solicitacao/find`;
        // if (page !== undefined) {
        let endpoint = `${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`;
        // }
        return stipAxios.post(endpoint, request);
    },
    getAlert: (params) => stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find`, params),
    deleteAlert: (params) => stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/delete`, params),
};

export default alertsEndpoint;
